import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
    dark: true,  // 👈 force global dark theme
    themes: {
      dark: {
        primary: '#90CAF9',
        // primary: '#38bdf8',
        secondary: '#0f172a',
        accent: '#a855f7',
        // you can add background, surface, etc. here if needed
      },
    },
  },
});
